import { CommonModule } from '@angular/common';
import { Component, NgModule } from '@angular/core';
import { BirthdaysModule } from '@app/components/birthdays/birthdays.component';
import { FeaturedNewsModule } from '@app/components/featured-news/featured-news.component';
import { KpiChartsModule } from '@app/components/kpi-charts/kpi-charts.component';
import { MyNewsModule } from '@app/components/my-news/my-news.component';
import { OrganizationCalendarModule } from '@app/components/organization-calendar/organization-calendar.component';
import { RestaurantMenuModule } from '@app/components/restaurant-menu/restaurant-menu.component';
import { RssFeedsModule } from '@app/components/rss-feeds/rss-feeds.component';
import { FeatureToggleModule } from '@app/directives/feature-toggle.directive';
import { HideParentIfEmptyModule } from '@app/directives/hide-parent-if-empty.directive';
import { MarkComponentVisitedModule } from '@app/directives/mark-component-visited.directive';
import { LinkModule } from '@app/directives/link.directive';
import { InfoboxZoneModule } from '@app/components/infobox-zone/infobox-zone.component';
import { FilterByDepartmentModule } from '@app/components/filter-by-department/filter-by-department.component';
import { PowerBIModule } from '@app/components/power-bi/power-bi.component';

@Component({
  selector: 'imgroup-custom-today',
  templateUrl: './custom-today.component.html',
  styleUrls: ['./custom-today.component.scss']
})
export class CustomTodayComponent { }
@NgModule({
  declarations: [CustomTodayComponent],
  exports: [CustomTodayComponent],
  imports: [
    CommonModule,
    LinkModule,
    InfoboxZoneModule,
    FeaturedNewsModule,
    MyNewsModule,
    OrganizationCalendarModule,
    BirthdaysModule,
    RestaurantMenuModule,
    RssFeedsModule,
    HideParentIfEmptyModule,
    MarkComponentVisitedModule,
    FeatureToggleModule,
    KpiChartsModule,
    FilterByDepartmentModule,
    PowerBIModule,
  ]
})
export class CustomTodayModule { }
